<template>
  <div class="inside-wrapper">
    <button
      class="btn btn-info btn-block add-contact-btn"
      data-target="#newInventoryItemModal"
      data-toggle="modal"
      @click.prevent="addInventory()"
    >
      Add inventory item
    </button>
    <div v-if="showAddItemPopup" class="new-row">
      <div
        v-if="showAddItemPopup"
        id="newInventoryItemModal"
        aria-hidden="true"
        aria-labelledby="addContactModal"
        class="modal fade"
        data-backdrop="false"
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" style="display: flex; padding: 5px 15px;">
              <h4
                id="addContactModal"
                class="modal-title"
                style="margin-left:35%"
              >
                Add New Item
              </h4>
              <button
                aria-label="Close"
                class="close"
                data-dismiss="modal"
                style="margin-left: auto"
                type="button"
              >
                <span aria-hidden="true" @click="cancelAddItem()">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="display: flex">
              <form id="addInventoryItemForm">
                <div class="form__group">
                  <textarea
                    v-model="newInventoryItem.description"
                    id="description"
                    class="form__field"
                    placeholder="Description"
                    rows="4"
                  ></textarea>
                  <label for="description" class="form__label"
                    >Description</label
                  >
                </div>

                <div class="form__group">
                  <input
                    v-model="newInventoryItem.quantity"
                    type="number"
                    id="quantity"
                    class="form__field validate"
                    placeholder="Quantity"
                    autocomplete="off"
                    required
                    min="0"
                  />
                  <i class="fas fa-list-ol input-icon"></i>
                  <!--                  <i class="fas fa-user-circle "></i>-->
                  <label for="quantity" class="form__label">Quantity</label>
                </div>
                <div class="form__group">
                  <input
                    v-model="newInventoryItem.price"
                    type="number"
                    id="price"
                    class="form__field validate"
                    placeholder="Price"
                    autocomplete="off"
                    required
                    min="0"
                  />
                  <i class="fas fa-dollar-sign input-icon"></i>
                  <label for="price" class="form__label">Price</label>
                </div>
                <Select
                  :items="dictionaries.general.countries"
                  :images="true"
                  :mainKey="'name'"
                  :placeholder="'country'"
                  @select="setSelectedCountry"
                  :iconClass="'fas fa-globe'"
                />
                <Select
                  :items="inventoryCategories"
                  :images="false"
                  :mainKey="'category'"
                  :placeholder="'category'"
                  @select="setSelectedCategory"
                  :iconClass="'fas fa-layer-group'"
                />
                <Select
                  :items="brands"
                  :images="false"
                  :placeholder="'brand'"
                  @select="setSelectedBrand"
                  :iconClass="'fas fa-building'"
                  :mainKey="'name'"
                />

                <div class="form__group">
                  <input
                      v-model="newInventoryItem.serial_number"
                      type="text"
                      id="serial_number"
                      class="form__field validate"
                      placeholder="Serial number"
                      autocomplete="off"
                      required
                  />
                  <i class="fas fa-barcode input-icon"></i>
                  <label for="serial_number" class="form__label">S/N</label>
                </div>

                <!--                <div class="form__group">-->
                <!--                  <input-->
                <!--                    v-model="newInventoryItem.phone"-->
                <!--                    type="tel"-->
                <!--                    id="telInput"-->
                <!--                    class="form__field"-->
                <!--                    placeholder="Phone number"-->
                <!--                    autocomplete="off"-->
                <!--                    required-->
                <!--                  />-->
                <!--                  <i class="fas fa-phone input-icon"></i>-->
                <!--                  <label for="telInput" class="form__label">Phone number</label>-->
                <!--                  <span-->
                <!--                      class="reset-select"-->
                <!--                      @click="newInventoryItem.phone = ''"-->
                <!--                      v-if="newInventoryItem.phone"-->
                <!--                  ><i class="fas fa-times"></i-->
                <!--                  ></span>-->
                <!--                </div>-->
                <!--                <div class="form__group">-->
                <!--                  <input-->
                <!--                    v-model="newInventoryItem.address"-->
                <!--                    type="tel"-->
                <!--                    id="addressInput"-->
                <!--                    class="form__field"-->
                <!--                    placeholder="Address"-->
                <!--                    autocomplete="off"-->
                <!--                    required-->
                <!--                  />-->
                <!--                  <i class="fas fa-address-card input-icon"></i>-->
                <!--                  <label for="addressInput" class="form__label">Address</label>-->
                <!--                </div>-->
                <!--                <div class="form__group">-->
                <!--                  <input-->
                <!--                    type="file"-->
                <!--                    id="imageInput"-->
                <!--                    class="form__field"-->
                <!--                    placeholder="Profile image"-->
                <!--                    autocomplete="off"-->
                <!--                    required-->
                <!--                  />-->
                <!--                  <i class="fas fa-address-card input-icon"></i>-->
                <!--                  <label for="imageInput" class="form__label">Profile image</label>-->
                <!--                </div>-->
                <UploadFileInput
                  :editMode="false"
                  @selectImage="setProfileImage"
                />
                <div class="btn-wrapper">
                  <button
                    v-if="showAddItemPopup"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click.prevent="cancelAddItem()"
                  >
                    CANCEL
                  </button>
                  <button
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #2ea591; color: white; font-size: 11px"
                    @click.prevent="saveNewInventoryItem()"
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
// import CountrySelect from "@/features/projects.feature/contacts/components/AddContactForm/CountrySelect.component";
import Select from "@/features/projects.feature/inventory/components/AddInventoryItemForm/Select.component";
import UploadFileInput from "@/features/projects.feature/inventory/components/AddInventoryItemForm/UploadFileInput.component";

export default {
  name: "AddInventory",
  components: { UploadFileInput, Select },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  mounted(){
    this.getInventoryCategories();
    this.getBrands();
  },
  data() {
    return {
      brands: [],
      inventoryCategories: [],
      newInventoryItem: {
        code: null,
        brand: null,
        category: null,
        description: "",
        img: null,
        price: null,
        status_id: 1,
        quantity: null,
        serial_number: null,
      },
      showAddItemPopup: false
    };
  },
  methods: {
    addInventory() {
      this.showAddItemPopup = !this.showAddItemPopup;
    },
    cancelAddItem() {
      this.showAddItemPopup = false;
      this.clearForm();
    },
    clearForm() {
      document.getElementById("addInventoryItemForm").reset();
          this.newInventoryItem.code = null;
          this.newInventoryItem.brand = null;
          this.newInventoryItem.category = null;
          this.newInventoryItem.description = "";
          this.newInventoryItem.img = null;
          this.newInventoryItem.price = null;
          this.newInventoryItem.status_id = 1;
          this.newInventoryItem.quantity = null;
          this.newInventoryItem.serial_number = null;
    },
    getBrands() {
     apiClientCreator("projects/inventory/brands").get("").then(res => {
      this.brands = res.data
     })
    },
    async getInventoryCategories(){
      const categoryInventoryRequest = apiClientCreator(
          `projects/inventory/categories`
      );
      await categoryInventoryRequest
          .get("")
          .then(res => {
            this.inventoryCategories =res.data
                });
    },
    async saveNewInventoryItem() {
      try {
        this.$store.commit("clients/setLoading", true);

        const addNewInventoryItemRequest = apiClientCreator(
          `projects/inventory/add`
        );

        const newInventoryItem = {
          category_id: this.newInventoryItem.category.id,
          brand_id: this.newInventoryItem.brand.id,
          country_id: this.newInventoryItem.country.id,
          description: this.newInventoryItem.description,
          img: this.newInventoryItem.img,
          price: this.newInventoryItem.price,
          status_id: this.newInventoryItem.status_id,
          quantity: this.newInventoryItem.quantity,
        };





        await addNewInventoryItemRequest
          .post("", newInventoryItem)
          .then(res => {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "New Contact Added successfully",
              type: "DONE",
              op: { type: "SYSTEM" }
            });
            this.clearForm();
            this.showAddItemPopup = false;
            // $("#addContactModal").modal("hide");
            this.$emit("fetchInventory");
          });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error adding c: ${e} Error Status: `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.cancelAddItem();
      }
    },
    setSelectedCountry(country) {
      this.newInventoryItem.country = country;
    },
    setSelectedCategory(category) {
      this.newInventoryItem.category = category;
    },
    setSelectedBrand(brand) {
      this.newInventoryItem.brand = brand;
    },
    setProfileImage(imgSrc) {
      this.newInventoryItem.img = imgSrc;
    }
  },

};
</script>

<style scoped lang="scss">
$bgColor: #009788;
$borderColor: #01756a;

.new-row {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
form {
  width: 100%;
}
.inside-wrapper {
  padding: 0px 5px;
}
.add-contact-btn {
  height: 40px;
  background-color: $bgColor;
  border-color: $borderColor;
}
.add-contact-btn:focus,
.add-contact-btn:active {
  height: 40px;
  background-color: $borderColor;
  border-color: $bgColor;
}

/*Inputs custom style starts ############################################################# */
.form__group {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;
}
.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d2d2d2;
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  font-size: 16px;
  cursor: text;
  top: 20px;
}

label,
.form__field:focus ~ .form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 12px;
  color: #9b9b9b;
}

.form__field:focus ~ .form__label {
  color: $bgColor;
}
.form__field:focus ~ .input-icon {
  color: $bgColor;
}

.form__field:focus {
  padding-bottom: 6px;
  border-bottom: 2px solid $bgColor;
}
/*Inputs custom style ends ############################################################# */
.modal-content {
  padding: 5% 5% 5% 7%;
}
.input-icon {
  position: absolute;
  left: -30px;
  top: 25px;
  font-size: 1.9rem;
}

.btn-wrapper {
  text-align: right;
}

.btn-wrapper button {
  margin-left: 10px;
  margin-top: 20px;
  height: 35px;
  opacity: 0.8;
}

.btn-wrapper button:hover {
  opacity: 1;
}
.reset-select {
  position: absolute;
  cursor: pointer;
}
input#file {
  display: inline-block;
  width: 100%;
  padding: 120px 0 0 0;
  height: 100px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: url("https://cdn1.iconfinder.com/data/icons/hawcons/32/698394-icon-130-cloud-upload-512.png")
    center center no-repeat #e4e4e4;
  border-radius: 20px;
  background-size: 60px 60px;
}
</style>
